import React from 'react';
import { Collapse, Checkbox, Divider } from 'antd';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Icon from '@mui/material/Icon';

const { Panel } = Collapse;

const ReviewBoxList = (props) => {
    const build_check_process = (order) => (
        <Checkbox
            style={{ marginRight: '15px' }}
            checked={order ? order.checked === 1 ? true : false : false}
            onClick={event => {
                event.stopPropagation();
            }}
            onChange={() => {
                props.updateDataOrdersChecked(order);
            }}>
        </Checkbox>
    )

    const buildDeleteBtn = (order) => (
        <BasicPopconfirm
            label='Eliminar orden'
            title='¿Seguro/a que deseas eliminar orden?'
            onConfirm={() => { props.deleteOrder(order) }}
            button={
                <IconButton color="error" aria-label="delete" onClick={(e) => e.stopPropagation()}>
                    <DeleteIcon />
                </IconButton>
            }
        />
    )

    const genExtra = (order) => (
        <div>

            <IconButton style={{ marginRight: '10px' }} color="primary" aria-label="pdf"
                onClick={(e) => { e.stopPropagation(); props.displayPDF(order); }}>
                <PictureAsPdfIcon />
            </IconButton>
            {
                build_check_process(order)
            }
        </div>
    );

    const buildTotalValue = (data) => {
        let total = 0;
        data.forEach(element => {
            total += (element.price * element.quantity);
        });
        return total;
    }

    return (
        <Collapse
            defaultActiveKey={[]}
            expandIconPosition={'right'}
        >
            {
                props.data.map((d, key) => {
                    return (
                        <Panel
                            style={{ backgroundColor: '#DFFFD9', fontWeight: 'normal' }}
                            key={key + 1}
                            extra={genExtra(d)}
                            header={
                                <>
                                    <strong style={{ marginRight: '20px' }}>{`Orden: ${d.id}`}</strong>
                                    <strong>{`Cliente: ${d.ordersDetail.length > 0 ? d.ordersDetail[0].productPrice ? d.ordersDetail[0].productPrice.client ? d.ordersDetail[0].productPrice.client.name : '' : '' : ''}`}</strong>
                                    <Chip style={{ marginLeft: '20px' }} label={`Entrega: ${d.date_delivery ? d.date_delivery : 'INMEDIATA'}`} size='small' color="warning" variant="outlined" />
                                </>
                            }
                        >
                            {
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={12}>
                                        <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                            Dirección de envío: {d.address_delivery}
                                        </span>
                                    </Grid>
                                    <Divider style={{ marginTop: '-1px', marginBottom: '-10px' }} />
                                    <Grid container spacing={1}>
                                        <Grid item xs={2} md={2}>
                                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                                Producto
                                            </span>
                                        </Grid>
                                        <Grid item xs={2} md={2}>
                                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                                Color
                                            </span>
                                        </Grid>
                                        <Grid item xs={1} md={1}>
                                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                                Cantidad
                                            </span>
                                        </Grid>
                                        <Grid item xs={1} md={1}>
                                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                                                Medida
                                            </span>
                                        </Grid>

                                    </Grid>
                                    {
                                        d.ordersDetail.map((od, key) => {
                                            if (od.inspected === 'PASS') {
                                                return (
                                                    <Grid key={key + 'itemOd'} container spacing={1}>
                                                        <Grid item xs={2} md={2}>
                                                            <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                                                                {od.productPrice ? od.productPrice.product ? od.productPrice.product.ref : '' : ''}
                                                            </span>
                                                        </Grid>
                                                        <Grid item xs={2} md={2}>
                                                            <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                                                                {od.color ? od.color.cod : ''}
                                                            </span>
                                                        </Grid>
                                                        <Grid item xs={1} md={1}>
                                                            <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                                                                {od.quantity ? od.quantity : ''}
                                                            </span>
                                                        </Grid>
                                                        <Grid item xs={1} md={1}>
                                                            <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                                                                {od.type_quantity ? od.type_quantity : ''}
                                                            </span>
                                                        </Grid>


                                                        <Grid item xs={2} md={2}>
                                                            <span style={{ fontSize: '9px' }}>
                                                                <select
                                                                    key={od.uuid}
                                                                    style={{ fontSize: '13px', padding: '2px' }}
                                                                    data-uuid={od.uuid}
                                                                >
                                                                    {props.process.map((obj) =>

                                                                        <option
                                                                            key={`${obj.cod}//${d.uuid}//${od.uuid}`}
                                                                            value={`${obj.cod}//${d.uuid}//${od.uuid}`}
                                                                        >
                                                                            {obj.name}
                                                                        </option>

                                                                    )}
                                                                </select>
                                                            </span>
                                                        </Grid>
                                                    </Grid>
                                                )
                                            }
                                        })
                                    }
                                    <Grid container spacing={1}>
                                        <Grid item xs={2} md={2}>
                                        </Grid>
                                        <Grid item xs={2} md={2}>
                                        </Grid>
                                        <Grid item xs={1} md={1}>
                                        </Grid>
                                        <Grid item xs={1} md={1}>
                                        </Grid>
                                        <Grid item xs={2} md={2}>

                                        </Grid>
                                        <Grid item xs={3} md={3}>
                                            <br />
                                        </Grid>
                                    </Grid>
                                    <Divider style={{ marginTop: '-20px' }} />
                                    <Grid item xs={12} md={12}>
                                        <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                                            NOTA: {d.notes}
                                        </span>
                                    </Grid>
                                </Grid>
                            }
                        </Panel>
                    );
                })
            }
        </Collapse>
    );


}
export default ReviewBoxList;